import { IWrappingInput } from "@types";

export type BalloonCountMap = Record<string, number>;

export const balloonsToCountMap = (balloons: any): BalloonCountMap => {
    const map: BalloonCountMap = {};
    if (!balloons || !Array.isArray(balloons)) return map;
    for (const b of balloons) {
        const id = b?.id;
        const count = b?.count;
        if (id === undefined || id === null) continue;
        const n = Math.max(0, Math.floor(Number(count) || 0));
        if (n > 0) map[String(id)] = n;
    }
    return map;
};

export const normalizeBalloonMap = (map: BalloonCountMap) => {
    const out: Array<[string, number]> = [];
    for (const [k, v] of Object.entries(map || {})) {
        const count = Math.max(0, Math.floor(Number(v) || 0));
        if (count > 0) out.push([String(k), count]);
    }
    // Stable sort for deterministic dirty checks.
    out.sort((a, b) => a[0].localeCompare(b[0]));
    return out;
};

export const isBalloonMapDirty = (current: BalloonCountMap, initial: BalloonCountMap) =>
    JSON.stringify(normalizeBalloonMap(current)) !== JSON.stringify(normalizeBalloonMap(initial));

export const isBalloonMapsDirty = (
    current: BalloonCountMap[],
    initial: BalloonCountMap[],
    qty: number
) => {
    const max = Math.max(current?.length || 0, initial?.length || 0, qty || 0);
    for (let i = 0; i < max; i++) {
        if (isBalloonMapDirty(current?.[i] || {}, initial?.[i] || {})) return true;
    }
    return false;
};

export const balloonsMapToModels = (map: BalloonCountMap, balloonList: IWrappingInput[]) => {
    const items: Array<{ id: number; name: string; price: any; media: any; count: number }> = [];
    const entries = Object.entries(map || {});
    for (const [idStr, count] of entries) {
        const n = Math.max(0, Math.floor(Number(count) || 0));
        if (!n) continue;
        const id = Number(idStr);
        const b = balloonList.find((x) => Number(x.id) === id);
        if (!b) continue;
        items.push({
            id: b.id,
            name: b.name,
            price: b.price,
            media: b.media,
            count: n,
        });
    }
    return items;
};
